// extracted by mini-css-extract-plugin
export default {"checkbox":"tDL6U8"};